








































































































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import Context from "@/mixins/context";
import { TaxTagTypesMap } from "@/data/enums/tax";
import {
  ITaxTagsProvider,
  ITaxTagsProviderMethods
} from "@/models/providers/tax";
import { ITaxTag } from "@/models/tax";

@Component
export default class TaxTagsTableView extends Mixins(Context) {
  // Inject
  @Inject({ from: "taxTagsProvider" })
  public taxTagsProvider!: () => ITaxTagsProvider;

  @Inject({ from: "taxTagsProviderMethods" })
  public $taxTagsMethods!: ITaxTagsProviderMethods;

  // Props
  @Prop({ default: true })
  public readonly isSimpleView!: boolean;

  @Prop({ default: false })
  public readonly isCheckable!: boolean;

  @Prop({ default: false })
  public readonly isSortable!: boolean;

  @Prop({ default: () => [] })
  public checkedTaxTagsIds!: ITaxTag["id"][];

  // Data
  public taxTagTypesMap = TaxTagTypesMap();

  // Computed
  public get $taxTagsData() {
    return this.taxTagsProvider();
  }

  public onRowClick(taxTag: ITaxTag) {
    this.$emit("row-click", taxTag);
  }

  public deleteTaxTag(taxTag: ITaxTag) {
    this.$emit("delete", taxTag);
  }

  public onCheck({ isChecked, taxTag }) {
    this.$emit("check", { isChecked, taxTag });
  }
}
